export default "__VITE_ASSET__H6SH92nw__"